export default {
  production: '//assets.shopfront.envato-static.com',
  development: '/assets'
}



// WEBPACK FOOTER //
// ./common/constants/assetsPath.js